import { type QueryFunctionContext, useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import * as qs from 'qs';

import type { ITableSorting } from '@model/tableSorting';

import { apiClient } from '@services/apiClient';

import { getRequestParams } from '../helpers/getRequestParams';
import type { ICartRange, IFilter } from '../model/engagementFilter';
import type {
  IEngagementStatsFacility,
  IUseEngagementStatsFacilityKeys,
} from '../model/engagementStatsFacility';

export const engagementStatsFacilityKey = (
  keys: IUseEngagementStatsFacilityKeys,
): [string, IFilter, ICartRange | undefined, Array<number>, ITableSorting | undefined] => [
  'engagementStatsFacility',
  keys.filter,
  keys?.cartRange,
  keys.locationIds,
  keys?.sorting,
];

export const engagementStatsFacilityFn = ({
  queryKey,
}: QueryFunctionContext<ReturnType<typeof engagementStatsFacilityKey>>) => {
  const { filterParams, sortParams } = getRequestParams({
    filter: queryKey[1],
    cartRange: queryKey[2],
    locationIds: queryKey[3],
    sorting: queryKey[4],
  });

  return apiClient.get(`${APP_API_URL_V2}fsd/action-item/report/engagement-stats/facility`, {
    params: {
      sort: [sortParams],
      filter: filterParams,
    },
    paramsSerializer: {
      serialize: (params) => qs.stringify(params),
    },
  });
};

const engagementStatsFacilitySelect = ({ data }: AxiosResponse<{ data: IEngagementStatsFacility }>) =>
  data.data;

export const useEngagementStatsFacilityQuery = (keys: IUseEngagementStatsFacilityKeys) => {
  return useQuery({
    queryKey: engagementStatsFacilityKey(keys),
    queryFn: engagementStatsFacilityFn,
    select: engagementStatsFacilitySelect,
    enabled: keys.enabled,
    keepPreviousData: true,
  });
};
